export const SOMETHING_WENT_WRONG = "SOMETHING_WENT_WRONG";
export const MIDH_DUPLICATE_CROP_EXCEPTION = "MIDH_DUPLICATE_CROP_EXCEPTION";
export const NEW_FARMER = "New Farmers Registered";
export const APPLICATION_SUBMITTED = "Applications Submitted for Schemes";
export const ESCALATION_ERROR =
  "This ticket has been escalated to a higher-level officer. You are unable to resolve it at this time.";
export const INVALID_ROLE = "INVALID ROLE";
export const PASSWORD_ERROR =
  "Password must be 8-15 characters long, contain at least one digit, one uppercase, one lowercase, one special character, and must not contain any spaces.";

export const LogoUrls = {
  INFORMATION_Logo_Url:
    "https://filestoragedfs.blob.core.windows.net/publicresources/images/information.png",
  NEW_LAUNCHED_Logo_Url:
    "https://filestoragedfs.blob.core.windows.net/publicresources/images/newlaunched.png",
  ANNOUNCEMENT_Logo_Url:
    "https://filestoragedfs.blob.core.windows.net/publicresources/images/announcement.png",
};

export const customExceptions = {
  UserNotFoundException: "USER_NOT_FOUND_EXCEPTION",
  PasswordMismatchException: "INCORRECT_CURRENT_PASSWORD_EXCEPTION",
  RateLimitExceededException: "COMMON_MOBILE_RATE_LIMIT",
  "OTP.UNKNOWN_MOBILE_NUMBER": "COMMON_UNKNOWN_MOBILE_NUMBER_ERROR",
  "OTP.VALIDATION_UNSUCCESSFUL": "COMMON_OTP_VALIDATION_ERROR",
  FARMER_DOES_NOT_EXIST: "FARMER_DOES_NOT_EXIST",
};

export const days = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
